<mat-toolbar
  *ngIf="!hide"
  color="secondary"
  class="breadcrumb-toolbar mat-elevation-z3">

  <!-- LEFT -->
  <div class="breadcrumb-left">
    <span class="current-page">
      {{ breadcrumbs[breadcrumbs.length - 1] || 'Page' }}
    </span>
  </div>

  <!-- RIGHT -->
  <div class="breadcrumb-right">
    <nav class="crumbs">
      <ng-container *ngFor="let crumb of breadcrumbs; let last = last; let first = first">
        <mat-icon class="sep" *ngIf="!first">chevron_right</mat-icon>
        <span [class.current]="last">{{ crumb }}</span>
      </ng-container>
    </nav>
  </div>

</mat-toolbar>
